export const servicesObjOne = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'What are credits?',
  headline: 'Credits are Exchageable Coins for Prizes',
  description:
    'Credits are CookieBites\'s coins that you can exchange for FEATURES that can be used to redeem prizes or participate on monthly EVENTS.',
  buttonLabel: 'Get Started',
  imgStart: '',
  img: require('../../images/svg-2.svg'),
  alt: 'Credit Card'
};

export const servicesObjTwo = {
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Are you a company?',
  // ! This is an error
  headline: 'Do You Want to Be an Evento Sponsor?',
  description:
    "Contact us to discuss and plan about a series of activities to improve your meetings in a delicious way.",
  buttonLabel: 'Contact Us',
  imgStart: 'start',
  img: require('../../images/svg-9.svg'),
  alt: 'Vault'
};